<template>
  <div class="flex items-center justify-between px-4 h-20">
    <RouterLink
      v-if="backRoute"
      :to="backRoute"
      class="flex items-center"
    >
      <Icon
        icon="mdi:chevron-left"
        class="text-2xl"
      />
      <div class="font-[nunito] font-extrabold text-xl">
        {{ title }}
      </div>
    </RouterLink>
    <button
      v-else-if="canGoBack"
      type="button"
      class="flex items-center bg-transparent border-none p-0"
      @click="$router.back()"
    >
      <Icon
        icon="mdi:chevron-left"
        class="text-2xl"
      />
      <div class="font-[nunito] font-extrabold text-xl">
        {{ title }}
      </div>
    </button>
    <div
      v-else
      class="flex items-center"
    >
      <div class="h-6 w-6" />
      <div class="font-[nunito] font-extrabold text-xl">
        {{ title }}
      </div>
    </div>
    <div class="flex gap-3 items-center justify-center">
      <slot />
    </div>
  </div>
</template>
<script>

export default {
  props: {
    backRoute: {
      default: null,
      type: Object,
    },
    title: {
      required: true,
      type: String,
    },
    backDefault: {
      default: true,
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {
      canGoBack: this.backDefault && !!this.$router.options.history.state.back,
    };
  },
};
</script>
